import api from './api';

export const createSetupIntent = (clientId) =>
  api.post(`/clients/${clientId}/payment/setup-intent`).then((r) => r.data);

export const saveCard = (clientId, paymentMethodId) =>
  api.post(`/clients/${clientId}/payment/save-card`, { paymentMethodId }).then((r) => r.data);

export const removeCard = (clientId) =>
  api.delete(`/clients/${clientId}/payment/card`).then((r) => r.data);
